module.exports = __webpack_public_path__ + "static/img/b7.0856b4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/b7.jpg
// module id = R35a
// module chunks = 0